import { toast } from "react-toastify";

export const recaptchaValidate = async (verifyToken: () => Promise<{ success: boolean; message?: string }>): Promise<boolean> => {
	try {
		const { success, message } = await verifyToken();
		if (!success) {
			toast.error(message || "reCAPTCHA verification failed");
			return false;
		}
		return true;
	} catch (error) {
		toast.error("Error verifying reCAPTCHA");
		return false;
	}
};
